import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Grid, Col, Row,  } from "react-bootstrap";
import Card from "../../../components/Card/Card";
import { dominio } from "../../../routes_backend/routes.jsx";


const RequiAdjunto = () => {
  const [docEntry, setDocEntry] = useState('');
  const [file, setFile] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleDocEntryChange = (e) => {
    setDocEntry(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file || !docEntry) {
      Swal.fire({
        icon: 'warning',
        title: 'Campos incompletos',
        text: 'Por favor, completa todos los campos antes de enviar.',
      });
      return;
    }

    try {
      const reader = new FileReader();
      reader.onloadend = async () => {
        const base64String = reader.result.split(',')[1]; // Extrae solo la parte base64

        const payload = {
          DocEntry: docEntry,
          empresa: 'MOSA',
          doc: base64String,
        };

        try {
         
          const response = await axios.post(
            `${dominio}/postAdjuntosRequi_ADM`,
            payload
          );

          if (response.status === 200) {
            Swal.fire({
              icon: 'success',
              title: 'Éxito',
              text: 'Se ha actualizado el adjunto correctamente.',
              confirmButtonText: 'Aceptar',
            }).then(() => {
              window.location.reload(); // Refresca la página
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Hubo un error al guardar el archivo.',
            });
          }
        } catch (error) {
          console.error('Error al enviar los datos al servidor:', error);
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Error al enviar los datos al servidor.',
          });
        }
      };

      reader.readAsDataURL(file); // Convierte el archivo a base64
    } catch (err) {
      console.error('Error al procesar el archivo:', err);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Error al procesar el archivo.',
      });
    }
  };

  return (

  <div className="content text-center" style={{ textAlign: "center", alignItems: "center" }}>
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                category=""
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div className="content">
               


             
                    <div>
                      <div style={{ fontSize: "20px" }}>Compras - Actualizar Adjunto</div>
                      <br />
                      <br />
                 <div className="container mx-auto mt-5">
      {/* <h1 className="text-xl font-bold mb-4"> Adjuntos</h1> */}
     
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="docEntry" className="block font-medium mb-1">
            Autorizacion:
          </label>
          <input
            type="text"
            id="docEntry"
            value={docEntry}
            onChange={handleDocEntryChange}
            className="border p-2 w-full"
            placeholder="Ingrese el # Autorizacion"
          />
        </div>
        <div>
          <label htmlFor="file" className="block font-medium mb-1">
            Archivo adjunto PDF:
          </label>
          <input
            type="file"
            id="file"
            onChange={handleFileChange}
            className="block w-full"
          />
        </div>
        <button
          type="submit"
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          Enviar
        </button>
      </form>
    </div>
                    </div>

                  </div>


                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    





  );
};

export default RequiAdjunto;
